import { Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Eye, EyeOff, LucideAngularModule, RefreshCw } from 'lucide-angular';
import { AuthService } from '../../core/services/auth.service';
import { ToastService } from '../../shared/ui/toast.service';

@Component({
  standalone: true,
  imports: [ReactiveFormsModule, LucideAngularModule],
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.css'],
})
export class LoginPage {
  protected readonly auth = inject(AuthService);
  private readonly toast = inject(ToastService);
  private readonly fb = inject(FormBuilder);
  protected readonly EyeIcon = Eye;
  protected readonly EyeOffIcon = EyeOff;
  protected readonly RefreshCwIcon = RefreshCw;
  protected showPassword = false;
  protected securityCode = this.generateSecurityCode();

  protected readonly form = this.fb.nonNullable.group({
    username: ['', Validators.required],
    password: ['', Validators.required],
    securityText: ['', Validators.required],
  });

  protected refreshSecurityCode(): void {
    this.securityCode = this.generateSecurityCode();
    this.form.controls.securityText.setValue('');
  }

  protected async submit(): Promise<void> {
    if (this.form.invalid) return;

    const { username, password, securityText } = this.form.getRawValue();
    if (securityText.trim() !== this.securityCode) {
      this.toast.show('Security text mismatch', 'Please enter the shown security text correctly.', 'info');
      return;
    }

    try {
      await this.auth.login(username, password);
      this.toast.show('Welcome back', 'You have been logged in successfully.', 'success');
    } catch {
      this.toast.show('Login failed', 'Invalid username or password.', 'danger');
    }
  }

  private generateSecurityCode(): string {
    return Math.floor(100000 + Math.random() * 900000).toString();
  }
}
